  // klaviyo 邮箱弹窗
  const windowBtns = $('.close-window-btn')
  windowBtns.click(function() {
    const $this = $(this)
    $this.parents('.klaviyo-window-box').removeClass('active')
  })


  const notifyBtns = $('.notify-btn')
  notifyBtns.click(function() {
    const $this = $(this)
    const parent = $this.parents('.section-notify')
    parent.find('.klaviyo-window-box').addClass('active')
  })